import client from '../client';
import { TApiSubset } from './Subset';
import queryString from "query-string";

export type TApiSet = {
  id: number;
  url: string;
  name: string;
  category: string;
  description: string;
  subsets: Array<TApiSubset>;
}

type TApiSetListParams = {
  param?: Array<string>
}


const list = (params?: TApiSetListParams): Promise<Array<TApiSet>> => {
  return client.get('/set/', {
    params: {
      ...(params?.param && { param: params.param })
    },
    paramsSerializer: params => queryString.stringify(params)
  }).then(response => response.data);
};

export {
  list
}
